const API_URL = import.meta.env.PROD ? "/api/v1" : (import.meta.env.VITE_API_URL ?? "http://localhost:3000/api/v1");

export class ApiError extends Error {
  constructor(message: string, public readonly code: string, public readonly status: number) { super(message); }
}

function cookie(name: string) {
  return document.cookie.split("; ").find((item) => item.startsWith(`${name}=`))?.split("=").slice(1).join("=");
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (!(init.body instanceof FormData) && init.body && !headers.has("content-type")) headers.set("content-type", "application/json");
  const csrf = cookie("asc_mail_csrf");
  if (csrf && !["GET", "HEAD"].includes((init.method ?? "GET").toUpperCase())) headers.set("x-csrf-token", decodeURIComponent(csrf));
  const response = await fetch(`${API_URL}${path}`, { ...init, headers, credentials: "include" });
  if (response.status === 204) return undefined as T;
  const payload = (await response.json().catch(() => ({}))) as { data?: T; error?: { code: string; message: string } };
  if (!response.ok || payload.error) throw new ApiError(payload.error?.message ?? "Request failed", payload.error?.code ?? "REQUEST_FAILED", response.status);
  return payload.data as T;
}

export async function apiWithMeta<T, M>(path: string): Promise<{ data: T; meta: M }> {
  const response = await fetch(`${API_URL}${path}`, { credentials: "include" });
  const payload = (await response.json()) as { data: T; meta: M; error?: { code: string; message: string } };
  if (!response.ok || payload.error) throw new ApiError(payload.error?.message ?? "Request failed", payload.error?.code ?? "REQUEST_FAILED", response.status);
  return payload;
}

export async function uploadMailAsset(file: File, kind: "ATTACHMENT" | "INLINE_IMAGE") {
  const body = new FormData();
  body.set("file", file);
  body.set("kind", kind);
  return api<{ id: string; originalFilename: string; size: number; mimeType: string; url: string }>("/mail/assets", { method: "POST", body });
}

export async function importMailAsset(url: string) {
  return api<{ id: string; originalFilename: string; size: number; mimeType: string; url: string }>("/mail/assets/import", {
    method: "POST",
    body: JSON.stringify({ url })
  });
}

export const absoluteAssetUrl = (value: string) => value.startsWith("http") ? value : `${API_URL.replace(/\/api\/v1$/, "")}${value}`;
export const eventUrl = (mailboxId: string) => `${API_URL}/mail/events?mailboxId=${encodeURIComponent(mailboxId)}`;
